import React from 'react';
import './index.less';

function PayoutErrorMessage({ error }) {
	return (
		<div
			className='payout-table--body--error-message'
			title={error}
		>
			{error}
		</div>
	);
}

export default PayoutErrorMessage;


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/payouts/components/table/components/payout-body/components/payout-error-message/index.js